<div class=flexBoxOuter>
    <div>
        <app-vjs-player (onVideoLoadStarted)="playWasCalled($event)"
            (showVideoPlayer)="changeShowActorVideoPlayer($event)" *ngIf="showActorVideoPlayer"
            [options]="optionsForActorVideo"></app-vjs-player>
        <app-loading-spinner class="loadingSpinner" *ngIf="!showActorVideoPlayer"></app-loading-spinner>
    </div>

    <table class="promptAndResponse">
        <tr>
            <td class="promptOrResponseLabel">Prompt</td>
            <td>{{promptText}}</td>
        </tr>
        <tr>
            <td class="promptOrResponseLabel">Response</td>
            <td *ngIf="data.StudentResponse.Transcript">{{data.StudentResponse.Transcript}}</td>
            <td *ngIf="!data.StudentResponse.Transcript" style="color: gray; font-style:italic">no response</td>
        </tr>
    </table>
    <div>
        <app-vjs-player (onVideoLoadStarted)="playWasCalled($event)" *ngIf="showStudentVideoPlayer"
            (showVideoPlayer)="changeShowStudentVideoPlayer($event)"
            [options]="optionsForStudentVideo"></app-vjs-player>
        <app-loading-spinner class="loadingSpinner" *ngIf="!showStudentVideoPlayer"></app-loading-spinner>
    </div>

</div>